<template>
  <div class="productList">
    <breadcrumb v-bind:path2="this.cat2"></breadcrumb>

    <!--select order-->
    <div class="collection-header">
      <div class="filters-toolbar-wrapper">
        <div class="page-width">
          <div class="filters-toolbar__item-child">
            <p>{{ $t('sortBy') }} :</p>
            <el-select v-model="option" placeholder="Please Select sorting method" value="" @change="updateFilter">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <!--end select order-->

    <!--列表主题-->
    <div class="product-listing-container">
      <div class="page-width">
        <ul>
          <li v-for="(item, index) in list" v-bind:key="index" v-if="!item.IsStopSale">
            <div class="">
              <productCard
                v-if='$i18n.locale=="en"'
                v-bind:img="item.Thumbnail"
                v-bind:link="item.link"
                v-bind:name="item.Name"
                v-bind:isPromotion="item.IsPromotion"
                v-bind:price="item.Price"
                v-bind:item="item"
                v-bind:inCart="inCart"
                v-bind:quantity="item.Quantity"
                v-bind:key="index"
                v-bind:barcode="item.Barcode"
              ></productCard>
              <productCard
                v-if='$i18n.locale=="ch"'
                v-bind:img="item.Thumbnail"
                v-bind:link="item.link"
                v-bind:name="item.Description"
                v-bind:isPromotion="item.IsPromotion"
                v-bind:price="item.Price"
                v-bind:item="item"
                v-bind:inCart="inCart"
                v-bind:quantity="item.Quantity"
                v-bind:key="index"
                v-bind:barcode="item.Barcode"
              ></productCard>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import breadcrumb from "@/components/breadcrumb";
import productCard from "./productCard";
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../store/modules/cart";
export default {
  name: "category2",
  components: {
    breadcrumb,
    productCard,
  },
  props: {
    cat2: {
      type: String,
    }
  },
  data() {
    return {
      option:"",//下拉框选项值
      //drop down
      options: [{
        value: '1',
        label: 'Alphabetically, A-Z'
      }, {
        value: '2',
        label: 'Alphabetically, Z-A'
      }, {
        value: '3',
        label: 'Price, low to high'
      }],
      recommendedSwiper: {
        slidesPerView: 5, // how many to shoe in a row
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        roundLengths : true,
        spaceBetween: 20,
        breakpoints: {
          320: {
              slidesPerView: 1,
          },
          //when width >= 480
          480:{
              slidesPerView: 2,
          },
          768: {
              slidesPerView: 4,
          },
          //when width >= 640
          990: {
              slidesPerView: 4,
          },
          1200:{
              slidesPerView: 4,
          },
          1280: {
              slidesPerView: 5,
          }
        }
      },
      list: []
    }
  },
  methods: {
    ...mapActions('products',['fetchProductsWithCategory2Id']),
    ...mapMutations('products', ['updateActiveProduct']),
    ...mapActions('cart', ['addProductToCart']),
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false
      }
      return item.InventoryQuantity > 0 ? false : true
    },
    updateFilter(value) {
      if(value === '1') {
        this.list = this.list.sort((a,b) => {
          return a.Name[0] > b.Name[0] ? 1 : -1;
        })
      }
      if(value === '2') {
        this.list = this.list.sort((a,b) => {
          return a.Name[0] < b.Name[0] ? 1 : -1;
        })
      }
      if(value === '3') {
        this.list = this.list.sort((a,b) => {
          return a.Price - b.Price;
        })
      }
    },
    fetchSelectedCategory2(id) {
      this.fetchProductsWithCategory2Id(id)
      .then(res => {
          let ctemp1 = [];
          let ctemp2 = [];
          let catOut = [];
          let catReg = [];
          res.data.map((a)=>{
            if (this.isOutOfStock(a)) {
              ctemp2.push(a)
            } else {
              ctemp1.push(a)
            }
          })
          catOut = ctemp2.sort((a,b)=>{
             return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
          });
          catReg = ctemp1.sort((a,b) => {
            return Number(a.GeneralNum) > Number(b.GeneralNum)?1:-1;
          })
          this.list = catReg.concat(catOut);
      })
      .catch(err => {
        console.log('err', err)
      })
    },
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item);
    },
    handleAddToCartFail() {
      alert('no enought product in stock');
    },
    addToCart: function(item) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item);
      }
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({ name: 'productDetails', query: { productNum: product.ProductNum} })
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('cart/getCart');
    next();
  },
  computed: mapState({
    allCategory2: state => state.products.customCategories,
    activeCategory2: state => state.products.activeCategory2,
    activeProduct: state => state.products.activeProduct,
    product: state => state.products.productDetails[0]
  }),
  watch: {
    // when hard refresh
    allCategory2: function(newVal, oldVal) {
      const currentCategory2 = newVal.filter(cat2 => {
        return cat2.Name.toLowerCase() === this.cat2.toLowerCase();
      });
      this.fetchSelectedCategory2(currentCategory2[0].ProductCategory2_id);
    },
    // when select a category2
    cat2: function(newVal, oldVal) {
      const currentCategory2 = this.allCategory2.filter(cat2 => {
        return newVal === cat2.Name.toLowerCase();
      });
      this.option = '';
      this.fetchSelectedCategory2(currentCategory2[0].ProductCategory2_id);
    }
  },
  mounted: function() {
    this.$store.dispatch('products/fetchCustomCategories',{company_id: 1,warehouse_id: 1});
    this.$root.fetchSelectedCategory2 = this.fetchSelectedCategory2.bind(this);
    const currentCategory2 = this.allCategory2.filter(cat2 => {
      return this.cat2 === cat2.Name.toLowerCase();
    });
    this.fetchSelectedCategory2(currentGroup[0].ProductCategory2_id)
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/productList.less";
</style>



// WEBPACK FOOTER //
// src/view/category2List.vue